import { render, staticRenderFns } from "./Governments.vue?vue&type=template&id=c728fdec&scoped=true&lang=html&"
import script from "./Governments.vue?vue&type=script&lang=js&"
export * from "./Governments.vue?vue&type=script&lang=js&"
import style0 from "./Governments.vue?vue&type=style&index=0&id=c728fdec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c728fdec",
  null
  
)

export default component.exports